export default __webpack_public_path__ + "static/media/doc.771e33c2.svg";